import React from "react";
import Carrusel from "../Components/Carrusel";
import Cards from "../Components/Cards";

const MarketPublico = () => {
  return (
    <div>

      <Carrusel></Carrusel>
      <Cards></Cards>
    </div>
  );
};

export default MarketPublico;
